import { z } from 'zod';

export const explainerSchema = z.object({
  statement: z.string().min(1),
});

export type Explainer = z.infer<typeof explainerSchema>;
